import script from "./rework.vue?vue&type=script&setup=true&lang=ts"
export * from "./rework.vue?vue&type=script&setup=true&lang=ts"

import "./rework.vue?vue&type=style&index=0&id=2c1a79e8&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c1a79e8"]])

export default __exports__